import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.anchor.lite.${suffix}`;
const propTypes = {
  anchorId: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  onAnchorRemove: PropTypes.func.isRequired
};
function AnchorPopoverBodyLite({
  anchorId,
  onEdit,
  onAnchorRemove
}) {
  const [iconButtons] = useState([{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onAnchorRemove
  }]);
  return /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
    "data-test-id": "anchor-popover-body-lite",
    iconButtons: iconButtons,
    i18nKey: i18nKey,
    children: /*#__PURE__*/_jsx(Box, {
      alignSelf: "center",
      paddingInlineStart: "300",
      paddingInlineEnd: "200",
      children: /*#__PURE__*/_jsxs(FormLabel, {
        padding: "0",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('label')
        }), /*#__PURE__*/_jsx(TruncateString, {
          display: "inline-flex",
          maxWidth: 100,
          children: anchorId
        })]
      })
    })
  });
}
AnchorPopoverBodyLite.propTypes = propTypes;
AnchorPopoverBodyLite.displayName = 'AnchorPopoverBodyLite';
export default AnchorPopoverBodyLite;